// Features: M004-F0716
// Tests: T-M004-0212 (phase B)
//
// What the page says after Core ACCEPTS a release (advice.release 200, Spec 1.4.0 ReleaseData: `stage`, `next_action`, `conditions[]`).
// Design 5.2 row 1, phase B: the sentence follows the stage of the 200 body, and only `sending_to_ledger` may keep the page waiting.
// Core's own sentences (conditions, next_action) are printed VERBATIM and first (ACCT-TX-011); WebUI words only add where the stage is.
import { inlineStage } from './stageInline';

export const SENDING_NOTICE = 'Core is sending this cost to the Ledger. It has not been confirmed yet.';
export const IN_ADVICE_NOTICE = 'The Ledger has this cost and it is in Advice. You can move it to the next invoice.';
export const ON_DRAFT_NOTICE = 'It is already on the next invoice.';

// -> { notice: string, waiting: boolean }. `waiting` true = keep the landing poll (only for sending_to_ledger or an answer with no stage).
export function releaseOutcome(accepted, handOffId) {
  const verbatim = accepted.conditions.map((condition) => `${condition.message} ${condition.nextAction}`.trim());
  if (accepted.nextAction && !accepted.conditions.some((condition) => condition.nextAction === accepted.nextAction)) verbatim.push(accepted.nextAction);
  const stage = accepted.stage;
  if (stage === 'dispatch_failed') {
    const view = inlineStage({ stage, nextAction: accepted.nextAction || accepted.conditions.find((c) => c.nextAction)?.nextAction || '', handOffId });
    const lines = verbatim.slice();
    lines.push(view.text);
    if (view.nextMissing) lines.push(view.nextAction);
    return { notice: lines.join(' '), waiting: false };
  }
  if (accepted.conditions.length) return { notice: verbatim.join(' '), waiting: false };
  if (stage === 'sending_to_ledger') return { notice: '', waiting: true };
  if (stage === 'handed_off' || stage === 'advice') return { notice: IN_ADVICE_NOTICE, waiting: false };
  if (stage === 'draft') return { notice: ON_DRAFT_NOTICE, waiting: false };
  const known = inlineStage({ stage, handOffId });
  if (known) return { notice: known.text, waiting: false };
  return { notice: '', waiting: true };
}
